<template>
  <sc-page-base
    title="Relatórios">

    <div class="page-analytic-report__wrap-content">

      <section
        v-for="(report, index) of reports"
        :key="index"
        class="page-analytic-report__wrap-content__item">

        <sc-card
          class="page-analytic-report__card"
          :class="{ 'page-analytic-report__card--active': report.isOpen }"
          :link="true">

          <template slot="image">
            <figure
              class="page-analytic-report__card__figure"
              :class="{ 'page-analytic-report__card__figure--active': report.isOpen }">

              <template v-if="report.pathName">
                <router-link
                  class="page-analytic-report__card__link"
                  :class="{ 'page-analytic-report__card__link--active': report.isOpen }"
                  :to="{ name: report.pathName }">
                  <img
                    class="page-analytic-report__card__image"
                    :class="{ 'page-analytic-report__card__image--active': report.isOpen }"
                    :src="report.image" />
                </router-link>
              </template>

              <template v-if="report.isOpen !== null">
                <a
                  href
                  class="page-analytic-report__card__link"
                  :class="{ 'page-analytic-report__card__link--active': report.isOpen }"
                  @click.prevent="toggleContent(report)">
                  <img
                    class="page-analytic-report__card__image"
                    :class="{ 'page-analytic-report__card__image--active': report.isOpen }"
                    :src="report.image" />
                </a>
              </template>
            </figure>
          </template>

          <template slot="body">
            <div class="page-analytic-report__card__content">
              <p class="title is-6">
                <template v-if="report.pathName">
                  <router-link
                    :to="{ name: report.pathName }"
                    class="page-analytic-report__card__full-link">
                    <span class="has-text-truncated page-analytic-report__card__full-link__text">{{ report.title }}</span>
                    <sc-icon :icon="report.icon"/>
                  </router-link>
                </template>

                <template v-else-if="report.isOpen !== null">
                  <a
                    href
                    @click.prevent="toggleContent(report)"
                    class="page-analytic-report__card__full-link">
                    <span class="has-text-truncated page-analytic-report__card__full-link__text">{{ report.title }}</span>
                    <sc-icon :icon="report.isOpen ? 'times' : report.icon"/>
                  </a>
                </template>

                <template v-else>
                  <span class="has-text-truncated page-analytic-report__card__full-link__text">{{ report.title }}</span>
                  <sc-icon :icon="report.icon"/>
                </template>
              </p>

              <component
                v-if="report.component"
                :is="report.component"/>

            </div>
          </template>
        </sc-card>

      </section>
    </div>
  </sc-page-base>
</template>

<script>
  import {
    ScPageBase,
    ScCard,
    ScIcon,
  } from '@intelipost-js/secure-components';

  import PageReportTotalQuote from './pages/total-quote/ReportTotalQuote';
  import ReportFreightCost from './pages/freight-cost/ReportFreightCost';

  export default {
    data() {
      return {
        overflow: 'visible',
        reports: [
          {
            title: 'Entregas',
            pathName: 'report-performance',
            icon: 'truck',
            image: '/static/images/logo-intelipost.png',
            isOpen: null,
          },
          {
            title: 'Performance por Transportadora',
            pathName: 'report-provider',
            icon: 'chart-line',
            image: '/static/images/logo-intelipost.png',
            isOpen: null,
          },
          {
            title: 'Pedidos despachados',
            pathName: 'report-delivered-provider',
            icon: 'chart-pie',
            image: '/static/images/logo-intelipost.png',
            isOpen: null,
          },
          {
            title: 'Relatório de uso',
            icon: 'file-alt',
            image: '/static/images/logo-intelipost.png',
            isOpen: false,
            component: PageReportTotalQuote,
          },
          {
            title: 'Custo de frete',
            icon: 'dollar-sign',
            image: '/static/images/logo-intelipost.png',
            isOpen: false,
            component: ReportFreightCost,
          },
        ],
      };
    },
    methods: {
      toggleContent(report) {
        Object.assign(report, {
          isOpen: !report.isOpen,
        });
      },
    },
    components: {
      ScPageBase,
      ScCard,
      ScIcon,
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@intelipost-js/secure-ui/src/scss/variables"; // eslint-disable-line

  $animationEaseInOut: all ease-in-out 0.3s;

  .page-analytic-report {
    &__wrap-content {
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;

      @media (max-width: 768px) {
        flex-direction: column;
      }

      &__item {
        flex-grow: 0;
        width: 330px;
        padding: 1rem;

        @media (min-width: 1250px) {
          height: 312px;
        }

        @media (max-width: 768px) {
          padding: 1rem 0;
        }

        @media (max-width: 500px) {
          width: 280px;
        }
      }
    }

    &__card {
      height: 280px;
      min-height: 280px;
      transition: $animationEaseInOut;

      @media (max-width: 768px) {
        height: 305px;
      }

      @media (max-width: 500px) {
        height: 268px;
        min-height: auto;
      }

      &__full-link {
        &__text {
          line-height: 22px;
          max-width: 240px;
        }
      }

      &__content {
        transition: $animationEaseInOut;
      }

      &__link {
        display: flex;
        align-items: center;
        justify-content: center;

        height: 222px;
        width: 100%;
        opacity: 1;
        transition: $animationEaseInOut;

        &--active {
          height: 0;
          opacity: 0;
        }
      }

      &--active {
        height: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/PageReports.vue?073d98f2